import moment from 'moment';
import get from 'lodash/get';

export const getBackgroundColorCell = (record, index, customer) => {
  const recordDueDate = record.months[index] ? record.months[index].due_date : null;
  const respCompetAt = customer.resp_compet_at || customer.registered_at || customer.created_at;
  if (respCompetAt && moment(recordDueDate).isBefore(respCompetAt)) {
    return '#d9d9d9';
  }
  if (record.months[index]) {
    if (record.months[index].revised_at !== null) return '#52c41a';
    if (record.months[index].executed_at !== null) return '#b7eb8f';
    if (record.months[index].status === 'Vencida') return '#ff4d4f';
    return '#ffffb8';
  }
  return '#fafafa';
};

export const handleDrawerClose = (data, date, customers, updateContextTasksCardsFromGrid, updateTasksCardsFromGrid, onClose, setLoading, setCustomers) => {
  if (!data) return;
  const dueDate = data.due_date || '';
  const isCurrentDateEqualsSelectedDate = dueDate.slice(0, 7) === moment().format('YYYY-MM');
  if (isCurrentDateEqualsSelectedDate) {
    updateContextTasksCardsFromGrid(customers, date.month() + 1, data.id);
  } else {
    updateTasksCardsFromGrid(customers, date.month() + 1, data.id);
  }
  setLoading(true);
  setCustomers([]);
  onClose();
};
